import { FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";


const FAQData = [
    {
        questNo: 1,
        quest: "How does Kwik Engage improve customer engagement?",
        response:
            "Kwik Engage enables two-way personalized campaigns, automates customer journeys, and provides deep insights for data-driven marketing.",
    },
    {
        questNo: 2,
        quest: "Can Kwik Engage integrate with my Shopify store?",
        response:
            "Yes! Kwik Engage seamlessly integrates with Shopify, custom stores, and mobile apps.",
    },
    {
        questNo: 3,
        quest: "What channels does Kwik Engage support?",
        response:
            "It works across WhatsApp, Email, SMS, Instagram, Facebook, and on-site pop-ups.",
    },
    {

        questNo: 4,
        quest: "How does KwikPass identify anonymous users?",
        response:
            "We utilize advanced fingerprinting, combined with phone-first OTP authentication, to instantly recognize visitors—even without traditional logins.",
    },
    {

        questNo: 5,
        quest: "What are smart marketing pop-ups?",
        response:
            " They are interactive, personalized pop-ups that appear as soon as visitors land on your site, offering discounts and capturing key customer data.",
    },
    {
        questNo: 6,
        quest: "Is customer data secure with KwikPass?",
        response:
            "Absolutely. We follow industry-best security standards to protect customer data.",
    },

];
export const SectionFive = () => {

    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const isMobile = useMediaQuery({ maxWidth: 768 });

    return (
        <div className="section-five-Ind">
            <div
                style={{
                    minHeight: "70vh",
                    padding: "0",
                    boxSizing: "border-box"
                }}
            >
                <div
                    style={{
                        maxWidth: "700px",
                        margin: isMobile ? "0 20px " : "0 auto",

                    }}
                >
                    <h1
                        style={{
                            textAlign: "center",
                            color: "#000",
                            fontSize: "2.5rem",
                            fontWeight: 500,
                            marginBottom: "36px",
                            fontFamily: "Inter, Arial, sans-serif"
                        }}
                    >
                        FAQs
                    </h1>
                    <div>
                        {FAQData.map((faq, idx) => (
                            <div
                                key={faq.questNo}
                                style={{
                                    background: "#fff",
                                    borderRadius: "7px",
                                    boxShadow: "0 1px 2px 0 rgba(16,24,40,0.04)",
                                    marginBottom: "16px",
                                    overflow: "hidden",
                                    border: "1px solid #eee"
                                }}
                            >
                                <button
                                    style={{
                                        width: "100%",
                                        background: "transparent",
                                        border: "none",
                                        outline: "none",
                                        padding: 0,
                                        cursor: "pointer",
                                        textAlign: "left"
                                    }}
                                    onClick={() => toggleAccordion(idx)}
                                    aria-expanded={activeIndex === idx}
                                    aria-controls={`faq-response-${idx}`}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            fontSize: "1.1rem",
                                            fontWeight: 500,
                                            color: "#111",
                                            padding: "18px 20px",
                                            fontFamily: "Inter, Arial, sans-serif"
                                        }}
                                    >
                                        <span>{faq.quest}</span>
                                        <span
                                            style={{
                                                marginLeft: "20px",
                                                color: "#222",
                                                fontSize: "19px",
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                        >
                                            {activeIndex === idx ? <FiMinus /> : <FaPlus />}
                                        </span>
                                    </div>
                                </button>
                                <div
                                    id={`faq-response-${idx}`}
                                    style={{
                                        maxHeight: activeIndex === idx ? "200px" : "0",
                                        overflow: "hidden",
                                        background: "#fff",
                                        transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                                        padding: activeIndex === idx ? "0 20px 16px 20px" : "0 20px",
                                        opacity: activeIndex === idx ? 1 : 0,
                                        fontSize: "1.05rem",
                                        color: "#333"
                                    }}
                                >
                                    {activeIndex === idx && (
                                        <div style={{ paddingTop: "4px", paddingBottom: "2px" }}>
                                            {faq.response}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}


